import { Message } from 'lib-shared-legacy-types';
import { memo } from 'react';

import {
  isMessengerCustomFormMessage,
  MessageCustomForm,
} from './MessageCustomForm';
import { isMessengerMenuMessage, MessageWidgetMenu } from './MessageWidgetMenu';
import TextMessage, { TextMessageProps } from './TextMessage';
import { createAttachedFiles } from './utils/AttachedFile';
import { useTranslatePlainTextConversationMessage } from './utils/useTranslatePlainTextConversationMessage';

type MessageWidgetChatProps = {
  message: Message;
} & TextMessageProps;

const MessageWidgetChat = memo(function MessageWidgetChat(
  props: MessageWidgetChatProps,
): JSX.Element {
  const { button, translation } = useTranslatePlainTextConversationMessage({
    text: props.message.text ?? undefined,
    originalLanguageCode: props.message.language ?? null,
    contentType: props.message.content_type === 'Html' ? 'html' : 'text',
  });

  if (isMessengerCustomFormMessage(props.message)) {
    return <MessageCustomForm {...props} message={props.message} />;
  }

  if (isMessengerMenuMessage(props.message)) {
    return <MessageWidgetMenu {...props} message={props.message} />;
  }

  return (
    <TextMessage
      {...props}
      attachments={createAttachedFiles(props.message.attached_files)}
      gutterButtons={button}
      translation={translation}
    />
  );
});

export default MessageWidgetChat;
